import { render, staticRenderFns } from "./addReport.vue?vue&type=template&id=76520bc0&scoped=true"
import script from "./addReport.vue?vue&type=script&lang=ts"
export * from "./addReport.vue?vue&type=script&lang=ts"
import style0 from "./addReport.vue?vue&type=style&index=0&id=76520bc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76520bc0",
  null
  
)

export default component.exports